export default __webpack_public_path__ + "static/media/belly-photo-BG.f34d01f3.png";